<template>
<div>
  <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
          <div v-for="(item, i) in data" :key="i" class="carousel-item" :class="{ active: i === 0 }" data-interval="4000">
            <template v-if="item.ancla">
              <a :href="item.ancla" target="_blank">
                <img :src="urlSitioNuevo+'estructura/img-slider/'+item.url" class="d-block w-100">
              </a>
            </template>
            <template v-else>
              <img :src="urlSitioNuevo+'estructura/img-slider/'+item.url" class="d-block w-100">
            </template>
          </div>


        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
<!-- <pre>{{ data }}</pre> -->
</div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import Carusel from "@/services/AvisoPrivacidad/AvisoPrivacidad.service.js";
const _carusel = new Carusel();

export default {

  name: 'carusel',
  computed:{

   },
    mounted(){
      this.carusel()
    },
    data() {
      return {
        data: [],
        rutaImg: ''
      }
    },
  components: {
  },
  methods:{
    async carusel() {
      try {
          const response = await _carusel.getCarusel(mapFun.carusel);
          this.data = response.data;
          console.log(this.data);

      } catch (error) {
          console.log('error', error.message);
      }
    },

  }

}
</script>
